var _filter, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomSofDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4F46E5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2563EB",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1E293B",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0F172A",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "dropShadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 4,
    floodOpacity: 0.15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 50)",
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 300,
    rx: 12,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 460,
    height: 260,
    rx: 8,
    fill: "url(#screenGradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 10,
    rx: 5,
    fill: "#ffffff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 180,
    height: 10,
    rx: 5,
    fill: "#06B6D4",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 220,
    height: 10,
    rx: 5,
    fill: "#ffffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 160,
    height: 10,
    rx: 5,
    fill: "#EC4899",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 40,
    r: 5,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 40,
    r: 5,
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 40,
    r: 5,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,300 L320,300 L300,350 L260,350 Z",
    fill: "#E2E8F0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 150)",
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 220,
    rx: 15,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 100,
    height: 180,
    rx: 8,
    fill: "url(#screenGradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 80,
    height: 30,
    rx: 4,
    fill: "#06B6D4",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 80,
    height: 40,
    rx: 4,
    fill: "#ffffff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 130,
    width: 80,
    height: 40,
    rx: 4,
    fill: "#ffffff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 210,
    r: 8,
    stroke: "#E2E8F0",
    strokeWidth: 2,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 400)",
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 8,
    fill: "#61DAFB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40,
    rx: 25,
    ry: 10,
    fill: "none",
    stroke: "#61DAFB",
    strokeWidth: 3,
    transform: "rotate(0 40 40)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40,
    rx: 25,
    ry: 10,
    fill: "none",
    stroke: "#61DAFB",
    strokeWidth: 3,
    transform: "rotate(120 40 40)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40,
    rx: 25,
    ry: 10,
    fill: "none",
    stroke: "#61DAFB",
    strokeWidth: 3,
    transform: "rotate(-120 40 40)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 400)",
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,10 L65,20 L60,60 L40,70 L20,60 L15,20 Z",
    fill: "#DD0031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,10 L40,70 L60,60 L65,20 Z",
    fill: "#C3002F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,20 L25,50 L32,50 L35,42 L45,42 L48,50 L55,50 Z",
    fill: "#ffffff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 400)",
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,20 L50,35 L60,20 L40,55 L20,20 L30,20 L40,35 Z",
    fill: "#41B883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,20 L40,35 L50,20",
    fill: "#35495E"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(350, 400)",
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,20 C50,20 60,30 60,40 C60,50 50,60 40,60 C30,60 20,50 20,40 C20,30 30,20 40,20",
    fill: "#539E43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,30 L45,30 L45,50 L35,50 Z",
    fill: "#ffffff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 400)",
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,25 C40,25 50,25 50,35 L50,45 C50,55 40,55 30,55 C20,55 20,45 20,35 L20,25 Z",
    fill: "#366994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,25 C20,25 20,35 20,45 L20,55 C20,65 30,65 40,65 C50,65 50,55 50,45 L50,35 Z",
    fill: "#FFD43B"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(550, 400)",
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#3178C6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 48,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 24
  }, "TS"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#E2E8F0",
    strokeWidth: 2,
    strokeDasharray: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400,350 L400,380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,380 L650,380"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 200,
    r: 20,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 200,
    r: 20,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 100,
    r: 15,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 300,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 300,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#6366F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSofDev);
export default __webpack_public_path__ + "static/media/custom_sof_dev.7ca6ff15d4e148b59c295cc53ddb0593.svg";
export { ForwardRef as ReactComponent };